/* This file is autogenerated, see readme.md for instructions */
import ChevronDownSvgIcon from '@bloomreach/banana-theme/icons/chevron-down.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ChevronDownIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ChevronDownSvgIcon />
    </Icon>
  );
});

ChevronDownIcon.displayName = 'ChevronDownIcon';

export default ChevronDownIcon;
